export default {
  token: "token",
  adminToken: "admin-token",
  tutor: "show-tutor",
  steps: "steps",
  dashboardFilter: "dashboard-filter",
};
